import React, { Component } from 'react'
import { connect } from 'react-redux'

import { 
  Glyphicon, Form,
  Checkbox, 
  ListGroup, ListGroupItem
} from "react-bootstrap"

import BlockPreview from './BlockPreview.jsx'
import { getRouteLength } from '../../lib/TripTools.js'
import isObjectEqual from '../../lib/isObjectEqual.js'
import CitySelector from '../cities/CitySelector.jsx'
import { makeGetBlockCities } from '../selectors' 
import Button from '../components/Button.jsx'
import { getText, nameOrTitle } from '../lib/text'

type BlockSelectorProps = {
  Activities: Object, 
  BlocksList: Object[], 
  selected: ?string, 

  Routes: Object, 

  addBlock: Function,
  replaceWithBlock: Object => void, 

  getBlockCities: string => Set<string>,
  filter: boolean,
  filterCity: string,
  toggleFilter: boolean => void, 
  changeFilterCity: string => void
}

class BlockSelector extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = { preview: null }
  }

  props: BlockSelectorProps;

  replaceWithBlock(b) {
    if (confirm(getText("replace_all_with_block"))) {
      this.props.replaceWithBlock(b)
    }
  }

  addBlock(b, last) {
    this.props.addBlock({...this.props.allRoutes[b.route], name : nameOrTitle(b)}, last)
  }

  render() {
    const list = this.props.filter
      ? this.props.BlocksList.filter(b => {
        const c = this.props.getBlockCities(b._id)
        return c && c.has(this.props.filterCity)
      })
      : this.props.BlocksList
      
    return (
      <div>
        {
          this.state.preview && (
            <BlockPreview 
              Activities={this.props.Activities}
              block={this.state.preview}
              route={this.props.Routes[this.state.preview.route]}
              onClose={() => this.setState({preview: null})}
            />
          )
        }

        <Checkbox
          checked={this.props.filter}
          onChange={evt => this.props.toggleFilter(evt.target.checked)}
        >
          {getText("filter_blocks")}
        </Checkbox>
        { 
          !this.props.filter ? "" : (
            <Form inline style={{maxWidth: 300}}>
              <CitySelector
                cityId={this.props.filterCity}
                labelWidth={50}
                onChange={city => this.props.changeFilterCity(city)}
              />
            </Form>
          )
        }
        
        <div style={{maxHeight: 500, overflowY: this.props.selected ? "hidden" : "scroll"}} >        
          <ListGroup style={{ marginTop: 10, border: "1px solid rgb(51, 122, 183)" }}>
            {
              list.length === 0
                ? (<em style={{padding: 15}}>Sin resultados</em>)
                : (
                  list.map(block => {
                    const selected = this.props.selected && block.route == this.props.selected._id
                    const routeLength = getRouteLength(this.props.Routes[block.route])

                    return (
                      <ListGroupItem 
                        key={block._id}
                        disabled={selected}
                      >
                        {nameOrTitle(block)} <small>({routeLength} {getText("días")})</small>

                        {
                          [
                            <Button
                              id="previsualizar"
                              key="previsualizar"
                              tooltipText={getText("Previsualizar")}
                              style={{ position: "absolute", right: 105 }}
                              bsSize="xsmall"
                              onClick={() => this.setState({ preview: block })}
                              glyph="search"
                            />,

                            <Button
                              id="añadir"
                              key="añadir"
                              tooltipText={getText("Añadir (elegir posición)")}
                              bsSize="xsmall"
                              style={{ position: "absolute", right: 75 }}
                              onClick={() => this.addBlock(block)}
                              glyph="plus"
                            />,

                            <Button
                              id="añadir-al-final"
                              key="añadir-al-final"
                              tooltipText={getText("Añadir al final de la ruta")}
                              bsSize="xsmall"
                              style={{ position: "absolute", right: 45 }}
                              onClick={() => this.addBlock(block, true /*last*/)}
                              glyph="fast-forward"
                            />,

                            <Button
                              id="reemplazar"
                              key="reemplazar"
                              tooltipText={getText("Reemplazar todo")}
                              bsSize="xsmall"
                              style={{ position: "absolute", right: 15 }}
                              onClick={() => this.replaceWithBlock(block)}
                            >
                              <img style={{ width: 12 }} src="/static/img/replace-icon.png" alt="reemplazar" />
                            </Button>
                          ]
                        }
                      </ListGroupItem>
                    ) 
                  })
                )
            }
          </ListGroup>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  getBlockCities: makeGetBlockCities(state, props), 
  allRoutes: state.routes, 
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(BlockSelector)
